import React from "react";

const FinancialRatio = ({ data }) => (
  <div className="howToInvestWrapper">
    <h3 className="heading-1-bold tableTitle">
      Financial Ratios for SBI Mutual Funds
    </h3>
    <div
      style={{ minHeight: "0.01%", overflowX: "auto" }}
    >
      <table className="w-100" cellspacing="0px">
        <tbody>
          <tr>
            {["SCHEME NAME", "STANDARD DEVIATION", "SHARPE RATIO", "SORTINO RATIO", "BETA", "ALPHA", "R-SQUARED"].map((item, id) =>
              (<th className={`para-4 tableColName ${id === 6 ? "text-right" : "text-left"}`}>
                {item}
              </th>))
            }
          </tr>

          {data.map((scheme, key) => (
            <tr className={`para-2`} key={key}>
              <td className="para-2-bold bold">{scheme["name"]}</td>
              <td className="para-2">{scheme["standard_deviation"]}</td>
              <td className="para-2">{scheme["sharp_ratio"]}</td>
              <td className="para-2">{scheme["sortino_ratio"]}</td>
              <td className="para-2">{scheme["beta"]}</td>
              <td className="para-2">{scheme["alpha"]}</td>
              <td className="para-2 text-right">{scheme["r_squared"]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <style jsx>{`
    .howToInvestWrapper{
      margin-bottom: 24px;
      padding-bottom: 32px;
    }
    .tableTitle{
      text-decoration: none;
       margin: 50px 0 16px;
    }    
    
    @media (max-width: 768px) {
      .howToInvestWrapper {
        padding-bottom: 0;
      }
    }
    `}</style>
  </div>
);

export default FinancialRatio;
